
import React, { Component } from "react";
import { translations } from "../../../translate.js";
import {
    UncontrolledDropdown,
    Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { Button, Drawer } from "@material-ui/core";
import { confirmAlert } from "react-confirm-alert";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Pagination from "react-js-pagination";
import { Picky } from "react-picky";
import "react-picky/dist/picky.css";
import SearchIcon from "@material-ui/icons/Search";
import { toAbsoluteUrl } from "../../../_metronic/index.js";
import { CircularProgress } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import EFAWATEERcomEditBiller from "./forms/eFAWATEERcomEditBiller.jsx";
import MoreVertIcon from "@material-ui/icons/MoreVert";


let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;
let today = new Date();
let currentDate =
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2);

export default class EFAWTEERcomServiceFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            loadingSave: 0,
            limit: "15",
            activePage: 1,
            dataCount: 0,
            searchKey: "",
            errorMsg: "",
            date: [],
            selectedDate: null,

            data: [],
            distributorList: [],
            distId: [],
            subervisorId: [],
            posId: [],

            debitDateFrom: currentDate,
            debitDateTo: currentDate,
            lastPayDateFrom: currentDate,
            lastPayDateTo: currentDate,
            openleftModal: false,
            modal: false,
            posCode: "",
            posCodeError: "",
            modalData: null,
            serialNumber: "",
            selectedMangerPos: [],
            mangerPos: [],

            classificationList: [],
            selectedClassification: [],

            billerList: [],
            selectedBiller: [],

            serviceName: "",

            openHeader: null,


        };
    }


    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;
        this.setState(
            {
                [name]: value,
                activePage: 1,
            },
            function () {
                if (name == "filterMode") {
                    this.handleRefresh();
                }
            }
        );
    };

    errorModal = (msg) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui alert-box-view">
                        <div className="mb-3">
                            <span className="alert-delete-icon">!</span>
                        </div>
                        <h5>{msg}</h5>
                        <button
                            type="button"
                            className="btn form-cancel-btn alert-btn-margin ml-2 mr-2"
                            onClick={onClose}
                        >
                            {Strings.Cancel}
                        </button>
                    </div>
                );
            },
        });
    };
    confirmBill2 = (event, id) => {
        event.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui alert-box-view">
                        <div className="mb-3">
                            <span className="alert-Succsess-icon">!</span>
                        </div>
                        <h5>{Strings["Are you sure ?"]}</h5>
                        <p>{Strings["You want to confirm this ?"]}</p>
                        <button
                            type="button"
                            className="btn form-cancel-btn alert-btn-margin ml-2 mr-2"
                            onClick={onClose}
                        >
                            {Strings.Cancel}
                        </button>
                        <button
                            type="button"
                            className="btn form-save-btn"
                            onClick={() => {
                                this.confirmBillHandler2(id);
                                onClose();
                            }}
                        >
                            {Strings.Yes}
                        </button>
                    </div>
                );
            },
        });
    };

    handleRefresh = () => {
        this.setState({
            activePage: 1,
            serviceName: "",
            selectedBiller: [],
            selectedClassification: [],

        }, function () {
            this.getData();

        });
    };


    handleSearch = async () => {


        try {
            this.setState({ loading: 1 });
            const body = {
                type: "getBillarListByCategoryCode",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                page: this.state.activePage,
                limit: this.state.limit,
                parent: 1,
                catCode: this.state.selectedClassification,
                searchBy: this.state.serviceName,
                pillarCode: this.state.selectedBiller,
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data !== "Nothing found") {
                if (data.logout === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else {
                    this.setState({
                        loading: 0,
                        data: data.data || [],
                        dataCount: parseInt(data?.count) || 0
                    });
                }
            } else {
                this.setState({
                    loading: 0,
                    data: [],
                    dataCount: 0
                });
            }

        }
        catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
        finally {
            this.setState({ loading: 0, loadingSave: 0 });
        }

    };

    componentDidMount() {

        this.getData();
        this.getClassification();
    }


    getClassification = async () => {
        const body = {
            type: "getEfwatercomCategoriesForAdmin",
            lang: localStorage.getItem("LANG"),
            userId: localStorage.getItem("USER_ID"),
            token: localStorage.getItem("USER_TOKEN"),
        };
        const response = await fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                Accept: "application/json",
            },
        });
        const data = await response.json();
        if (data.logout === 1) {
            localStorage.setItem("USER_ID", "");
            localStorage.setItem("USER_TOKEN", "");
            window.location.href = "/logout";
        } else {
            this.setState({ classificationList: data.efwatercomList });
        }
    }



    getData = async () => {
        try {
            this.setState({ loading: 1 });
            const body = {
                type: "getBillarListByCategoryCode",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                page: this.state.activePage,
                limit: this.state.limit,
                parent: 2,
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data !== "Nothing found") {
                if (data.logout === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else {
                    this.setState({
                        loading: 0,
                        data: data.data || [],
                        dataCount: parseInt(data?.count) || 0
                    });
                }
            } else {
                this.setState({
                    loading: 0,
                    data: [],
                    dataCount: 0
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
        finally {
            this.setState({ loading: 0, loadingSave: 0 });
        }
    }

    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, function () {

            this.handleSearch();


        });
    };



    handleUpdateService = async () => {
        this.setState({ loading: 1 });
        try {

            const body = {
                type: "refreshBillarListByCategoryCode",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data.logout === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.getData();
                this.setState({ loading: 0 });
            }

        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
    }


    openHeaderMenu = (event, id) => {
        event.preventDefault();
        if (
            event.target.classList[1] != undefined &&
            event.target.classList[1] == "menu-dots-vertical" &&
            id != undefined
        ) {
            var val = "";
            if (this.state.openHeader == id) {
                val = "";
            } else if (id != undefined) {
                val = id;
            }
            this.setState({
                openHeader: val,
            });
        } else if (
            id == undefined &&
            event.target.classList[1] != "menu-dots-vertical"
        ) {
            this.setState({
                openHeader: "",
            });
        }
    };

    openSidebarModal = (event, type, data, viewMode) => {
        event.preventDefault();
        console.log('Opening modal with data:', data, 'type:', type);
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.setState({
            propsData: data,
            actionType: type,
            viewMode: viewMode,
            openleftModal: true
        })
    }
    handleCloseSideBar = () => {
        this.setState({ openleftModal: false, propsData: [], actionType: '', viewMode: '' })
        this.handleSearch();
    }

    handleFormAction = (actionType, data) => {
        this.getData();
        this.handleCloseSideBar();
    }

    deleteService = (event, rowData) => {
        event.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui alert-box-view">
                        <div className="mb-3">
                            <span className="alert-delete-icon">!</span>
                        </div>
                        <h5>{Strings["Are you sure ?"]}</h5>
                        <p>{Strings["You want to delete this ?"]}</p>
                        <button
                            type="button"
                            className="btn form-cancel-btn alert-btn-margin ml-2 mr-2"
                            onClick={onClose}
                        >
                            {Strings.Cancel}
                        </button>
                        <button
                            type="button"
                            className="btn form-save-btn"
                            onClick={() => {
                                this.deleteServiceById(rowData);
                                onClose();
                            }}
                        >
                            {Strings.Yes}
                        </button>
                    </div>
                );
            },
        });
    }
    deleteServiceById = (rowData) => {
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "deleteServiceToCategory",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                codeService: rowData.codeService,
                categoryCodeId: rowData.categoryId,
            }),
            headers: {
                Accept: "application/json",
            },
        }).then(function (response) {
            return response.json();
        }).then(data => {
            if (data.logout == 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.getData();
            }
        });
    }
    getBillerList = async (selectedClassification) => {

        const response = await fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "getBillarListByCategoryCode",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                // page: this.state.activePage,
                // limit: this.state.limit,
                catCode: selectedClassification,
                parent: 0,
            }),
            headers: {
                Accept: "application/json",
            },
        })
        const data = await response.json();

        if (data.logout == 1) {
            localStorage.setItem("USER_ID", "");
            localStorage.setItem("USER_TOKEN", "");
            window.location.href = "/logout";
        } else {

            this.setState({
                billerList: data.data || []
            })
        }


    }
    handleChangeSelect = (type, option) => {
        if (type == 'selectedClassification') {
            this.setState(
                (state) => {
                    return {
                        [type]: option.map(item => item.code),

                    };
                }, function () {
                    this.getBillerList(this.state.selectedClassification);
                },
            );
        }
        else if (type == 'selectedBiller') {
            this.setState(
                (state) => {
                    return {
                        [type]: option.map(item => item.categoryId),
                    };
                }, function () {
                    // this.getBillerList(this.state.selectedClassification);
                },
            );
        }
    }
    render() {
        return (
            <div>

                <Row>
                    <Col lg={12} className="main-color-1 inv-class-view-title mb-4">
                        <div>

                            {Strings["E-fawatercom Service Fields"]}

                        </div>
                        <hr className="inv-hr-view-2" />
                    </Col>
                </Row>
                <Row className="page-filter-view">
                    <Col
                        xl={{ size: 9, order: 1 }}
                        lg={{ size: 9, order: 1 }}
                        md={{ size: 9, order: 1 }}
                        sm={{ size: 12, order: 1 }}
                        xs={{ size: 12, order: 1 }}
                    >
                        <AvForm ref={(c) => (this.form = c)} className="d-flex flex-column gap-3">
                            <Row>

                                <Col sm={5} xs={12} md={5} lg={5} className="mt-0">
                                    <Picky
                                        value={this.state.classificationList.filter(item =>
                                            this.state.selectedClassification?.includes(item.code)
                                        )}
                                        options={this.state.classificationList}
                                        onChange={(value) => {

                                            this.handleChangeSelect('selectedClassification', value);

                                        }}
                                        valueKey="code"
                                        labelKey="catName"
                                        multiple={true}
                                        includeSelectAll={true}
                                        includeFilter={true}
                                        dropdownHeight={200}
                                        placeholder={Strings["Classification"]}
                                        filterPlaceholder={Strings["Search Classification"]}

                                    />
                                </Col>
                                <Col sm={5} xs={12} md={5} lg={5} className="mt-0">
                                    {console.log(this.state.billerList)}
                                    <Picky
                                        value={(this.state.billerList || []).filter(item =>
                                            this.state.selectedBiller?.includes(item.categoryId)
                                        )}
                                        options={this.state.billerList || []}
                                        onChange={(value) => {
                                            this.handleChangeSelect('selectedBiller', value);
                                        }}
                                        valueKey="categoryId"
                                        labelKey="title"
                                        multiple={true}
                                        includeSelectAll={true}
                                        includeFilter={true}
                                        dropdownHeight={200}
                                        placeholder={Strings["Biller"]}
                                        filterPlaceholder={Strings["Search Biller"]}

                                    />
                                </Col>
                            </Row>

                            <Row className="mt-4 d-flex gap-5">
                                <Col sm={5} xs={12} md={5} lg={5}>
                                    <AvField
                                        name="serviceName"
                                        type="text"
                                        placeholder={Strings["Service name"]}
                                        value={this.state.serviceName}
                                        onChange={(event) => {
                                            this.setState({ serviceName: event.target.value });
                                        }}
                                    />

                                </Col>
                                <Col sm={5} xs={12} md={5} lg={5} className="d-flex justify-content-start">
                                    <Col sm={4} xs={12} md={4} lg={4}>
                                        <Button
                                            variant="contained"
                                            className="refresh-action-btn m-0"
                                            onClick={this.handleRefresh}
                                            title={Strings["Refresh"]}
                                            style={{ marginTop: "10px" }}
                                        >
                                            <i className="flaticon-refresh reset-filter-btn"></i>
                                        </Button>
                                    </Col>

                                </Col>
                            </Row>
                        </AvForm>
                    </Col>

                    <Col
                        xl={{ size: 3, order: 12 }}
                        lg={{ size: 3, order: 12 }}
                        md={{ size: 3, order: 12 }}
                        sm={{ size: 12, order: 12 }}
                        xs={{ size: 12, order: 12 }}
                        className="text-right mb-3  d-flex flex-column align-items-end gap-3 w-100 h-100"
                    >

                        <Col sm={8} xs={12} md={8} lg={8} className="mb-4 mt-3">
                            <button type="button" className="btn gradient-button-view gradient-button gradient-button-font-12 w-100 " onClick={() => this.handleUpdateService()}>
                                {Strings['Update Services']}
                            </button>
                        </Col>
                        <Col sm={5} xs={12} md={5} lg={5} className="mt-0">
                            <button
                                variant="contained"
                                className="btn form-save-btn mt-0 w-100"
                                onClick={(event) => {
                                    this.setState({ activePage: 1 }, function () {
                                        this.handleSearch();
                                    })
                                }
                                }
                            >
                                {Strings["Search"]}{" "}
                                <SearchIcon className="font-size-15  main-color-2" />
                            </button>
                        </Col>



                    </Col>
                </Row>
                {
                    this.state.loading == 0 && this.state.errorMsg != "" && (
                        <Row>
                            <div className="inv-cards-view pb-5 width-100">
                                <div
                                    className="text-center"
                                    style={{ marginTop: "15%", marginBottom: "15%" }}
                                >
                                    <img
                                        alt="Logo"
                                        src={toAbsoluteUrl(
                                            "/media/ezpay/EZPAY_LOGO_GRAY" + window.MAIN_IMAGE + ".png"
                                        )}
                                        className="img-fluid no-data-img"
                                    />
                                    <div className="no-data-text">{this.state.errorMsg}</div>
                                </div>
                            </div>
                        </Row>
                    )
                }
                {
                    this.state.loading == 0 &&
                    this.state.data.length <= 0 &&
                    this.state.errorMsg == "" && (
                        <Row>
                            <div className="inv-cards-view pb-5 width-100">
                                <div
                                    className="text-center"
                                    style={{ marginTop: "15%", marginBottom: "15%" }}
                                >
                                    <img
                                        alt="Logo"
                                        src={toAbsoluteUrl(
                                            "/media/ezpay/EZPAY_LOGO_GRAY" +
                                            window.MAIN_IMAGE +
                                            ".png"
                                        )}
                                        className="img-fluid no-data-img"
                                    />
                                    <div className="no-data-text">
                                        {Strings["There is no data to display"]}
                                    </div>
                                </div>
                            </div>
                        </Row>
                    )
                }
                {
                    this.state.loading == 1 && (
                        <Row>
                            <Col lg={12} style={{ marginTop: "7%" }} className="text-center">
                                <div className="card-body">
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                </div>
                            </Col>
                        </Row>
                    )
                }
                {
                    this.state.loading == 0 && this.state.data.length > 0 && (
                        <Row>
                            <div className="inv-cards-view width-100">
                                <Row className="table-header-row d-none d-lg-flex d-md-flex">
                                    <Col
                                        lg={11}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Point name"]}
                                    >
                                        {Strings["Service name"]}
                                    </Col>

                                    <Col
                                        lg={1}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Status"]}
                                    >
                                        {Strings["Edit"]}
                                    </Col>



                                </Row>
                                {this.state.data.map((rowData, index) => {
                                    return (
                                        <Row key={index} className="table-body-row">
                                            <Col
                                                lg={11}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                                className="overflow-text-length  order-2 order-md-1 order-lg-1 "
                                                title={Strings["Service name"]}
                                            >

                                                {rowData.title}
                                            </Col>

                                            <Col
                                                lg={1}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                                className="order-4 order-md-4 order-lg-4 action-icon-view actionDropdownList actionDropdownListPadding-0"
                                                style={{ overflow: "visible !important" }}
                                            >
                                                <Dropdown
                                                    isOpen={
                                                        this.state.openHeader == rowData["id"] ? true : false
                                                    }
                                                    toggle={() => {
                                                        if (this.state.openHeader == rowData.id) {
                                                            this.setState({ openHeader: null });
                                                        } else {
                                                            this.setState({ openHeader: rowData.id });
                                                        }
                                                    }}
                                                    className="font-size-13 actionDropdownList actionDropdownListPadding-0 orderlistActionlist"
                                                >
                                                    <DropdownToggle
                                                        tag="a"
                                                        className="nav-link pt-0 actionDropdownList  actionDropdownListPadding-0"
                                                        caret
                                                    >
                                                        <MoreVertIcon
                                                            className="menu-dots-vertical actionDropdownList"
                                                        />
                                                    </DropdownToggle>

                                                    <DropdownMenu
                                                        className="font-size-13 modal-left-0 actionDropdownList"
                                                        style={{
                                                            zIndex: 9999,
                                                            minWidth: "150px"
                                                        }}
                                                    >
                                                        <DropdownItem
                                                            className="actionDropdownList"
                                                            onClick={(event) =>
                                                                this.openSidebarModal(event, 'edit', rowData, false)
                                                            }
                                                        >
                                                            {Strings["Edit"]}
                                                        </DropdownItem>

                                                        <DropdownItem
                                                            onClick={(e) =>
                                                                this.deleteService(e, rowData)
                                                            }
                                                            className="actionDropdownList"
                                                        >
                                                            {Strings["Delete"]}
                                                        </DropdownItem>

                                                    </DropdownMenu>
                                                </Dropdown>
                                            </Col>


                                        </Row>
                                    );
                                })}
                                {this.state.loading == 0 && this.state.data?.length > 1 && (
                                    <Col md={12}>
                                        <Row className="pagenation-view mt-3 mb-4">
                                            <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.limit}
                                                totalItemsCount={this.state.dataCount}
                                                pageRangeDisplayed={4}
                                                onChange={this.handlePageChange}
                                                prevPageText={
                                                    <i
                                                        className={
                                                            localStorage.getItem("LANG") == 1
                                                                ? "flaticon2-next"
                                                                : "flaticon2-back"
                                                        }
                                                    ></i>
                                                }
                                                nextPageText={
                                                    <i
                                                        className={
                                                            localStorage.getItem("LANG") == 1
                                                                ? "flaticon2-back"
                                                                : "flaticon2-next"
                                                        }
                                                    ></i>
                                                }
                                                hideFirstLastPages
                                                innerClass={
                                                    "pagination  pagination-rounded justify-content-end pagenation-view my-2"
                                                }
                                                itemClass={"page-item"}
                                                linkClass={"page-link"}
                                            />
                                        </Row>
                                    </Col>
                                )}
                            </div>
                        </Row>
                    )
                }

                < Drawer anchor={localStorage.getItem('LANG') == 1 ? 'left' : 'right'} open={this.state.openleftModal} className='sidebar-modal-view' onClose={this.handleCloseSideBar} >

                    {
                        this.state.actionType == 'edit' && this.state.propsData && (
                            <EFAWATEERcomEditBiller
                                handleCloseSideBar={this.handleCloseSideBar}
                                data={this.state.propsData}
                                handleFormAction={this.handleFormAction}
                            />
                        )
                    }

                </Drawer >

            </div >
        );
    }
}
